const startViewTransition = (callback, disable) => {
  if (
    document.startViewTransition &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
    !disable
  ) {
    return document.startViewTransition(callback)
  } else {
    callback()
  }
}

export default startViewTransition
